import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Collections } from './components/Collections';
import { Catalog } from './components/Catalog';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { InstagramGallery } from './components/InstagramGallery';
import { FAQ } from './components/FAQ';
import { Delivery } from './components/Delivery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWidget } from './components/FloatingWidget';
export function App() {
  return <div className="min-h-screen bg-brand-cream" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Collections data-id="element-4" />
        <Catalog data-id="element-5" />
        <About data-id="element-6" />
        <Testimonials data-id="element-7" />
        <InstagramGallery data-id="element-8" />
        <FAQ data-id="element-9" />
        <Delivery data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingWidget data-id="element-13" />
    </div>;
}